<template>
    <div class="d-flex justify-content-center pt-4" v-if="isLoading">
        <div class="spinner-border" role="status">
            <span class="sr-only">{{ $t('loading') }}...</span>
        </div>
    </div>
</template>

<script>
    import BtTravelRepository from '@repositories/BtTravelRepository';

    export default {
        data() {
            return {
                isLoading: true,
            };
        },

        created() {
            const query = this.$route.query;

            let passengersNumber = 0;

            if (query.passengers) {
                query.passengers.forEach((p) => {
                    passengersNumber += parseInt(p.quantity);
                });
            }

            if (!query.passengers || passengersNumber < query.passengers_number) {
                query.passengers = [];
                query.passengers.push({
                    type: 'adult',
                    quantity: parseInt(query.passengers_number),
                });
            }

            this.$store.dispatch('businessTaxi/setSearchParameters', query).then(() => {
                BtTravelRepository.validateSearch(query)
                    .catch((e) => {
                        this.$router.push({ name: 'business-taxi.index' });

                        throw e;
                    })
                    .then(() => {
                        this.$router.replace({ name: 'business-taxi.vehicles' });
                    });
            });
        },
    };
</script>
